<template>

  <smd-one-col-layout class="modal-preview-file"
                      content-styles="full-width">
    <smd-header slot="header" nav>
      <smd-btn class="reset-mp"
               clean
               slot="left-actions">
        <span class="ns-icon-ico028"
              @click="modalGoBack"/>
      </smd-btn>
      <div class="Title3 gray-400 text-center">
        {{ title }}
      </div>

      <template slot="right-actions">
        <div class="flex-row-center-xy-spaced">
          <smd-btn :class="$isMobile || !showButton ? 'reset-mp': 'reset-m'"
                   clean>
        <span class="ns-icon-ico045"
              v-if="!isPrescriptionFile"
              @click="viewPrescriptionExternal"/>
            <span class="ns-icon-ico001"
                  v-else-if="isPrescriptionFile && $isMobile">
              <span class="path1"></span>
              <span class="path2"></span>
            </span>
          </smd-btn>
          <smd-btn v-if="isPrescriptionWithCouponExpired && !$isMobile && showButton && !filesView"
                   @click="modalAttachFile">
            <text-string label-id="txt063"/>
          </smd-btn>
        </div>
      </template>
    </smd-header>
    <div class="modal-preview-file__viewer"
         :class="computedClass">

      <full-screen-loader v-if="isLoading"/>
      <template v-else>
        <template v-show="!isPreviewImage">
          <pdf style="height: 100%"
               v-for="i in numPages"
               :key="i"
               :page="i"
               :src="pdfSrc"/>
        </template>

        <img v-show="isPreviewImage" ref="imagePreview" src="" width="100%" height="auto"/>

        <div class="file-selected" v-show="!pdfSrc && !this.isPreviewImage">
          <p>File selected</p>
          <p>Name:</p>
          <p> {{ pdfFileName }}</p>
        </div>
      </template>
    </div>

    <!--  For Files Page  -->
    <template v-if="filesView">
      <div class="modal-preview-file__bottom-nav"
           slot="bottom-nav"
           v-if="showButton">
        <smd-btn class="press-to-order"
                 section="1"
                 variant="enabled-blue"
                 v-if="attachingFilesEnabled && isPrescription && this.expiredCoupon"
                 @click="filesAttachFile">
          <div class="press-to-order__left-section" v-if="$isMobile">
            <img src="../assets/icons/ico048.svg" alt="pharmacy logo" width="144px ">
          </div>
          <div class="press-to-order__right-section">
            <div class="press-to-order__right-section-inner">
              <div class="press-to-order__right-section-text">
                <text-string class="text-transform-reset" label-id="txt043"/>
                <text-string label-id="txt247"/>
              </div>
              <img src="../assets/icons/img013.png" alt="press icon" width="32px">
            </div>
          </div>
        </smd-btn>

        <div class="custom-form-buttons" v-if="attachingFilesEnabled && isCustomForm">
          <smd-btn @click="filesAttachFile">
            <text-string label-id="txt304"/>
          </smd-btn>
        </div>

        <smd-coupon class="modal-preview-file__add-claim-sample"
                    v-if="couponClaimEnabled"
                    :btn-label="getElementString('txt339', {strings: [this.couponExpirationDate]})"
                    :btn-style="{section: '4', variant: 'red-enabled'}"
                    :item="coupon"
                    :title="coupon.shortname"
                    :description="getElementString('txt252')"
                    :image="couponImage"
                    @selected="addPrescriptionWithCoupon"/>
      </div>
    </template>

    <!-- For Pharmacy Orders Page  -->
    <template v-else>
      <div class="modal-preview-file__bottom-nav"
           slot="bottom-nav"
           v-if="showButton">
        <template v-if="isPrescriptionFile">
          <smd-btn section="2"
                   variant="left-enabled"
                   @click="modalGoBack">
            <text-string label-id="txt109"/>
          </smd-btn>
          <smd-btn v-if="attachingFilesEnabled"
                   section="2"
                   variant="right-blue-enabled"
                   @click="modalAttachFile">
            <text-string label-id="txt113"/>
          </smd-btn>
        </template>

        <smd-coupon class="modal-preview-file__add-claim-sample"
                    btn-label="Add to claim sample"
                    v-if="couponClaimEnabled"
                    :btn-style="{section: '4', variant: 'blue-enabled'}"
                    :item="coupon"
                    :title="coupon.shortname"
                    :description="getElementString('txt252')"
                    :image="couponImage"
                    @selected="addPrescriptionWithCoupon"/>

        <smd-btn section="1"
                 variant="enabled-blue"
                 v-if="attachingFilesEnabled && isPrescriptionWithCouponExpired && $isMobile"
                 @click="modalAttachFile">
          <text-string label-id="txt063"/>
        </smd-btn>
      </div>
    </template>
  </smd-one-col-layout>
</template>

<script>
  import PreviewFileMixin from '../mixins/preview-file-mixin';

  export default {
    name: "modal-preview-file",
    mixins: [PreviewFileMixin],
  }
</script>

<style lang="scss">
  @import "~@/assets/styles/util.scss";

  .modal-preview-file {
    .smd-header.nav {
      @include make-grid-cols(30px 1fr 30px, space(xs));
    }

    .press-to-order {
      @extend %layout--flex-row-center-x;
      height: 65px;
      position: absolute;
      bottom: 0;
    }

    .press-to-order__left-section {
      @extend %layout--flex-row-center-x;

      img {
        @include border-radius(radius(small));
        background: color(white);
      }
    }

    .press-to-order__right-section-inner {
      @extend %layout--flex-row-center-x;
      position: absolute;
      bottom: 0;
      right: space(m);

      img {
        margin-left: space(s);
      }
    }

    .press-to-order__right-section-text {
      margin-top: -13px;
    }

    .custom-form-buttons {
      position: absolute;
      bottom: 20px;
    }
  }

  .modal-preview-file__viewer {
    @extend %layout--flex-center-xy;
    background: color(gray-400);
    height: 100%;
    padding: space(xl) 0 space(xxl);

    > span {
      max-width: 900px;
      width: 100%;
    }

    &.image-preview {
      background: color(gray-900);

      > img {
        max-width: 900px;
      }
    }

    &.file-preview {
      background: color(gray-900);
      justify-content: flex-start;
      align-items: flex-start;
      padding: 10px;
    }

    .file-selected {
      color: color(white);
    }

    > span:not(:last-child) {
      margin-bottom: space(s);
    }
  }

  .modal-preview-file__bottom-nav {
    @extend %layout--flex-row-center-xy;
    background: color(gray-900);

    > button {
      bottom: 0;
    }
  }

  .modal-preview-file__add-claim-sample {
    @include responsive(desktop) {
      right: space(xl);
      bottom: space(xl);
    }
    position: absolute;
    bottom: space(s);
  }
</style>